import { Typography } from '@mui/material';

import { HeadingFormField } from 'types';
import { QuestionLabel } from 'components/question-label';

export const FormHeading = ({ label, subtitle }: HeadingFormField) => (
  <section className="col-span-full w-full pt-2 pb-3">
    <div role="heading" aria-level={2} className="text-xl font-semibold">
      <QuestionLabel value={label} />
    </div>
    {subtitle?.trim() && (
      <Typography variant="body1" className="mt-1" color="text.primary">
        {subtitle}
      </Typography>
    )}
  </section>
);
